module.exports = __webpack_public_path__ + "static/media/82.58212e1f.jpg";